<template>
    <van-dialog
        v-model="isCopyCreate"
        :title="$t('category.modal_title')"
        :showConfirmButton="false"
        :closeOnClickOverlay="true"
        ref="createForm"
        @close="resetForm">
        <input
            type="text"
            :class="{ isError }"
            v-model="form.title"
            class="category__input"
            :placeholder="$t('category.placeholder')" />
        <small v-if="isError">{{ $t('error.required') }}</small>
        <van-button type="primary" class="one" @click="save()" :loading="isSaving">
            {{ $t('category.done') }}
        </van-button>
    </van-dialog>
</template>


<script>
import ApiCategory from '@/api/category';
export default {
    props: {
        isCreate: {
            default: false,
            type: Boolean,
        },
    },
    data() {
        return {
            isError: false,
            isSaving: false,
            isCopyCreate: false,
            form: {},
        };
    },
    watch: {
        isCreate() {
            this.isCopyCreate = this.isCreate;
        },
    },
    methods: {
        save() {
            if (!this.form.title) {
                this.isError = true;
                return;
            }

            this.isError = false;
            this.isSaving = true;
            ApiCategory.createCategory(this.form).then((responce) => {
                this.isSaving = false;
                if (responce.err != 0) {
                    this.$notify(responce.err_msg[0], {
                        type: 'danger',
                    });
                } else {
                    this.resetForm();
                }
            });
        },
        resetForm() {
            this.form.title = '';
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
.category__input {
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #111;
    padding: 6px 12px;
    border: 1px solid #9e9e9e;
    border-radius: 6px;
    margin-bottom: 24px;
    width: 100%;
    outline: none;

    &.isError {
        border-color: red;
        margin-bottom: 0;
        & + small {
            margin-bottom: 24px;
            color: red;
            display: block;
        }
    }
    &::placeholder {
        color: #9e9e9e;
    }
}
</style>